const memoryStorage: { [key: string]: string } = {}

class StorageHelper {    
    useLocalStorage
    useSessionStorage
    
    constructor(useLocalStorage = true, useSessionStorage = true) {
        this.useLocalStorage = useLocalStorage && !/localhost/.test(typeof window !== "undefined" ? window.location.hostname : "")
        this.useSessionStorage = useSessionStorage
    }

    set(key: string, value: string) {
        if (this.useLocalStorage && typeof localStorage !== "undefined") {
            try {
                localStorage.setItem(key, value)
                return value
            }
            catch (e) {}
        }
        if (this.useSessionStorage && typeof sessionStorage !== "undefined") {
            try { 
                sessionStorage.setItem(key, value)
                return value
            }
            catch (e) {}
        }
        memoryStorage[key] = value
        return value
    }

    remove(key: string) {
        delete memoryStorage[key]
        if (this.useLocalStorage && typeof localStorage !== "undefined") {
            try {
                localStorage.removeItem(key)
            }
            catch (e) {}
        }
        if (this.useSessionStorage && typeof sessionStorage !== "undefined") {
            try {
                sessionStorage.removeItem(key)
            }
            catch (e) {}
        }
    }

    get(key: string) {
        if (this.useLocalStorage && typeof localStorage !== "undefined") {
            try {
                return localStorage.getItem(key)
            }
            catch (e) {}
        }
        if (this.useSessionStorage && typeof sessionStorage !== "undefined") {
            try {
                return sessionStorage.getItem(key)
            }
            catch (e) {}
        }
        return memoryStorage[key] || null
    }
}

const defaultStorageHelper = new StorageHelper()

export {
    StorageHelper,
    defaultStorageHelper
}